exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.secureContainer {\n  border: none;\n  margin: auto 0px;\n  width: 100%;\n}\n\n#secureContainerWrapper {\n  /*width: 470px;\n  overflow: hidden;*/\n  margin: 0px auto;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/ubuntu/MembriPay/src/app/components/payment/nuvei-checkout/nuvei-checkout-modal/nuvei-checkout-modal.component.css
// module id = ../../../../../src/app/components/payment/nuvei-checkout/nuvei-checkout-modal/nuvei-checkout-modal.component.css
// module chunks = main